import { z } from "zod";

export const FlowTypeSchema = z.enum(["DCT", "DCL", "DVD"]);

export const ImmatriculationFlowSchema = z.object({
  flowType: FlowTypeSchema,
  isActive: z.boolean(),
});
export const ImmatriculationFlowsResponseSchema = z.object({});

export const getImmatriculationFlowsResponseSchema = z.object({
  immatriculationFlows: z.array(ImmatriculationFlowSchema),
  total: z.number(),
});

export type FlowType = z.infer<typeof FlowTypeSchema>;

export type ImmatriculationFlow = z.infer<typeof ImmatriculationFlowSchema>;

export type GetImmatriculationFlowsResponse = z.infer<
  typeof getImmatriculationFlowsResponseSchema
>;
